// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"a0e7783d","513":"2bc21197","703":"19e96760"}[chunkId] + ".chunk.js";
};